export const homeFor = (user) => {
  const role = typeof user === "string" ? user : user?.role;
  if (role === "trainer") return user?.business_type === "group" ? "/trainer/group" : "/trainer";
  if (role === "instructor") return "/instructor";
  return user?.account_kind === "member" ? "/member" : "/client";
};
